import React from 'react';
import { Switch, Route } from 'react-router-dom';
import CourseCreator from './containers/course-creator/index';
import DefaultCourses from './containers/default-courses';
import MasterCourses from './containers/master-courses';
import SetDefaultCoursesWithLoader from './containers/set-default-courses';
import {
    DEFAULT_COURSES_ROUTE,
    MASTER_COURSES_ROUTE,
    COURSE_CREATOR_ROUTE,
    SET_DEFAULT_COURSES_ROUTE
} from './constants';

const Routes = () => (
    <Switch>
        <Route component={DefaultCourses} path={DEFAULT_COURSES_ROUTE} />
        <Route component={MasterCourses} path={MASTER_COURSES_ROUTE} />
        <Route component={SetDefaultCoursesWithLoader} path={SET_DEFAULT_COURSES_ROUTE} />
        {/* CLONE COURSE */}
        <Route component={CourseCreator} path={`${COURSE_CREATOR_ROUTE}${MASTER_COURSES_ROUTE}/:actionType/:productId/:masterCourseId/:version`} />
        {/* EDIT/COPY COURSE */}
        <Route component={CourseCreator} path={`${COURSE_CREATOR_ROUTE}${DEFAULT_COURSES_ROUTE}/:actionType/:productId/:defaultCourseId/version/:version`} />
        <Route component={DefaultCourses} path="/" />
    </Switch>
);

export default Routes;



// WEBPACK FOOTER //
// ./app/routes.js